import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Input, InputLabel, Typography } from '@material-ui/core';
import Select from '@material-ui/core/Select';

const FormSelect = ({
  input,
  label,
  meta: { touched, error },
  values,
  disabledValues,
  defaultItemName,
  helperText,
  ...custom
}) => (
    <React.Fragment>
      <FormControl error={touched && error} style={{ width: 182, marginTop: 16 }} {...custom}>
      {label ? <InputLabel htmlFor="dropdown" id="form-select-label">{label}</InputLabel> : null}
        <Select
          id="form-select"
          labelId="form-select-label"
          native
          label={label}
          value={input.value}
          onChange={event => input.onChange(event.target.value)}
          input={<Input inputProps={{ 'aria-label': label }} id={`dropdown`} />}
        >
          {defaultItemName ? <option value={null}>{defaultItemName}</option> : <option value={null} />}
          {values.map(value => (
            <option key={value.value} value={value.value} disabled={disabledValues && disabledValues.includes(value.value)}>{value.name}</option>
          ))}
        </Select>
      </FormControl>
      {helperText && <Typography variant="caption" component="div">{helperText}</Typography>}
    </React.Fragment>
  );

FormSelect.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  disabledValues: PropTypes.array,
  defaultItemName: PropTypes.string,
  helperText: PropTypes.string,
};

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormSelect.js